import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { supportedLanguages } from "./constants";

// Map browser lang codes -> internal codes
const browserToInternal = {
	at: "at",
	be: "be",
	cz: "cz",
	cs: "cz",
	"cs-cz": "cz",
	de: "de",
	"de-at": "at",
	nl: "nl",
	"nl-be": "be",
	en: "en",
	es: "es",
	fr: "fr",
	it: "it",
	lt: "lt",
	pl: "pl",
	ro: "ro",
	sk: "sk",
};

i18n
	// i18next-http-backend
	// loads translations from your server
	// https://github.com/i18next/i18next-http-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		debug: true,
		fallbackLng: "pl",
		supportedLngs: supportedLanguages,
		nonExplicitSupportedLngs: false,
		load: "languageOnly",
		detection: {
			order: ["localStorage", "navigator", "htmlTag"],
			caches: ["localStorage"],
			checkForSupportedLanguage: true,
			convertDetectedLanguage: (lng) => {
				// Normalize browser code to lowercase
				const lang = lng.toLowerCase();

				// Try exact match first (e.g. "de-at")
				if (browserToInternal[lang]) return browserToInternal[lang];

				// Fallback: only language part (e.g. "en-US" -> "en")
				const short = lang.split("-")[0];
				if (browserToInternal[short]) return browserToInternal[short];

				// Default fallback
				return "pl";
			},
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	});

export default i18n;

// const { t } = useTranslation();
// <Box>{t("hello_world")}</Box>
